import styled from 'styled-components'


export const StyledShape = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 10px 20px 10px 0;
	height: 75px;
	width: 75px;
	background-color: white;
	box-shadow: 0 1px 1px 0 rgba(90, 90, 90, 0.08);
	border-radius: 2px;
	&.active {
		background-color: #ffd91f;
	}
`

